import { render, staticRenderFns } from "./TaskItem.vue?vue&type=template&id=8acda2f8&scoped=true&"
import script from "./TaskItem.vue?vue&type=script&lang=ts&"
export * from "./TaskItem.vue?vue&type=script&lang=ts&"
import style0 from "./TaskItem.vue?vue&type=style&index=0&id=8acda2f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8acda2f8",
  null
  
)

export default component.exports